export default {"src":"/_next/static/media/arbIcon.70ecc994.svg","height":11,"width":10,"blurWidth":0,"blurHeight":0};